let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("9qSS1")).then(() => parcelRequire('4FhDj'));